import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import DataTable from '../Components/DataTable/DataTable';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Controllers from '../Api/Controllers';
import { FormCustom, Input, TextArea, CheckBox, Select } from '../Components/Form/Form';
import Helpers from '../Helpers/Helpers';
import { toast as toastr } from 'react-toastify';
import { useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import PresentationForm from './PurchaseOrdersForm'
import ReactPlaceholder from 'react-placeholder';
import Swal from 'sweetalert2';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';


const Compromiso = ({ idConsolidate, modalHide }) => {
  const [row, setRow] = useState({
    number_compromise: '',
    date_compromise: Helpers.date.get(),
    date_send_provider: '',
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: idConsolidate,
      p_number_compromise: row.number_compromise,
      p_date_compromise: row.date_compromise,
      p_date_send_provider: row.date_send_provider,
    }
  }, [row, idConsolidate])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_compromise(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    });
  }}>
    <Input
      type="number"
      text="Número Compromiso"
      placeholder="Número Compromiso"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, number_compromise: e.currentTarget.value })}
    />
    <Input
      type="date"
      text="Fecha Compromiso"
      placeholder="Fecha Compromiso"
      icon="far fa-calendar"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, date_compromise: e.currentTarget.value })}
      value={row.date_compromise}
    />
    {/* <Input
      type="date"
      text="Fecha Envío Proveedor"
      placeholder="Fecha Envío Proveedor"
      icon="far fa-calendar"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({...row, date_send_provider: e.currentTarget.value})}
      value={row.date_send_provider}
    /> */}
  </FormCustom>
}

const Notificado = ({ idConsolidate, modalHide }) => {
  const [row, setRow] = useState({
    date_send_provider: Helpers.date.get()
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: idConsolidate,
      p_date_send_provider: row.date_send_provider
    }
  }, [row, idConsolidate])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_notified(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    });
  }}>
    <Input
      type="date"
      text="Fecha Envío Proveedor"
      placeholder="Fecha Envío Proveedor"
      icon="far fa-calendar"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, date_send_provider: e.currentTarget.value })}
      value={row.date_send_provider}
    />
  </FormCustom>
}

const Devengado = ({ idConsolidate, modalHide }) => {
  const [row, setRow] = useState({
    number_devengade: '',
    date_devengade: Helpers.date.get()
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: idConsolidate,
      p_number_devengade: row.number_devengade,
      p_date_devengade: row.date_devengade
    }
  }, [row, idConsolidate])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_devengade(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    });
  }}>
    <Input
      type="number"
      text="Número Devengado"
      placeholder="Número Devengado"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, number_devengade: e.currentTarget.value })}
    />
    <Input
      type="date"
      text="Fecha Devengado"
      placeholder="Fecha Devengado"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, date_devengade: e.currentTarget.value })}
      value={row.date_devengade}
    />
  </FormCustom>
}

const EnviadoDAF = ({ idConsolidate, modalHide, isReenvied }) => {
  const [row, setRow] = useState({
    number_table: '',
    date_send_daf: Helpers.date.get()
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: idConsolidate,
      p_number_table: isReenvied ? '' : row.number_table,
      p_date_send_daf: row.date_send_daf
    }
  }, [row, idConsolidate, isReenvied])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_send_daf(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    });
  }}>
    {isReenvied ? '' : <Input
      type="number"
      text="Número Mesa Entrada"
      placeholder="Número Mesa Entrada"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, number_table: e.currentTarget.value })}
    />}
    <Input
      type="date"
      text="Fecha Envío"
      placeholder="Fecha Envío"
      icon="far fa-calendar"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, date_send_daf: e.currentTarget.value })}
      value={row.date_send_daf}
    />
  </FormCustom>
}

const Rechazado = ({ idConsolidate, modalHide }) => {
  const [row, setRow] = useState({
    date_rejection: Helpers.date.get(),
    justification_rejection: ''
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: idConsolidate,
      p_date_rejection: row.date_rejection,
      p_justification_rejection: row.justification_rejection
    }
  }, [row, idConsolidate])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_rejection(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    });
  }}>
    <Input
      type="date"
      text="Fecha Rechazo"
      placeholder="Fecha Rechazo"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, date_rejection: e.currentTarget.value })}
      value={row.date_rejection}
    />
    <TextArea
      text="Justificación"
      placeholder="Justificación"
      icon="far fa-calendar"
      classNameParent="col-12 mb-2"
      rows="5"
      required
      onChange={e => setRow({ ...row, justification_rejection: e.currentTarget.value })}
    />
  </FormCustom>
}

const Pagado = ({ idConsolidate, modalHide, numberPurchase }) => {
  const [row, setRow] = useState({
    date_pay: Helpers.date.get(),
    number_box: ''
  })

  const dataSumbit = useCallback(() => {
    let f = new FormData()
    f.append('p_id', idConsolidate)
    f.append('p_date_pay', row.date_pay)
    f.append('p_number', numberPurchase)
    f.append('p_number_box', row.number_box)
    f.append('p_pdf_document', row.pdf_document)
    return f
  }, [row, idConsolidate, numberPurchase])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_pay(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    });
  }}>
    <Input
      type="date"
      text="Fecha Pago"
      placeholder="Fecha Pago"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, date_pay: e.currentTarget.value })}
      value={row.date_pay}
    />
    <Input
      text="Número Caja"
      placeholder="Número Caja"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      maxLength={20}
      onChange={e => setRow({ ...row, number_box: e.currentTarget.value })}
      value={row.number_box}
    />
    <div className="col-12 mb-2">
      <Form.File id="formcheck-api-regular">
        <Form.File.Label>Selecionar PDF</Form.File.Label>
        <Form.File.Input required accept="application/pdf" onChange={e => {
          setRow({ ...row, pdf_document: e.currentTarget.files.length > 0 ? e.currentTarget.files[0] : '' })
        }} />
      </Form.File>
    </div>
  </FormCustom>
}

const Anulado = ({ idConsolidate, modalHide }) => {
  const [row, setRow] = useState({
    date_ban: Helpers.date.get(),
    justification_ban: ''
  })

  const dataSumbit = useCallback(() => {
    return {
      p_id: idConsolidate,
      p_date_ban: row.date_ban,
      p_justification_ban: row.justification_ban
    }
  }, [row, idConsolidate])

  return <FormCustom dataSubmit={dataSumbit()} onSubmit={({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_ban(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    });
  }}>
    <Input
      type="date"
      text="Fecha"
      placeholder="Fecha"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, date_ban: e.currentTarget.value })}
      value={row.date_ban}
    />
    <TextArea
      text="Justificación"
      placeholder="Justificación"
      icon="fas fa-code"
      classNameParent="col-12 mb-2"
      required
      onChange={e => setRow({ ...row, justification_ban: e.currentTarget.value })}
    />
  </FormCustom>
}

const ActaOrdenCompra = ({ idConsolidate, numberPurchase, modalHide }) => {
  const year = useSelector(store => store.session.year)
  const [listParticipants, setListParticipants] = useState([])
  const [listBooks, setListBooks] = useState([])
  const [participantSelected, setParticipantSelected] = useState('')
  const [row, setRow] = useState({
    number: '',
    date: Helpers.date.get(),
    hour: Helpers.date.get({ format: '%H:%i' }),
    id_participant: [],
    id_book: ''
  })
  const [isOk, setIsOk] = useState(false)
  const jwt = useSelector(store => store.session.jwt)
  useEffect(() => {
    let promises = [
      Controllers.participant.get_participant_public_actasoc(),
      Controllers.book.get_book_public(),
      Controllers.orders.get_orders_purchaseorder_act({ p_id: idConsolidate })
    ]
    Promise.all(promises).then(([resParticipants, resBooks, resAct]) => {
      const participants = resParticipants.data || []
      const books = resBooks.data || []
      setListParticipants(participants)
      setListBooks(books)

      const act = resAct.data || {}
      const hasExistingAct = !!act.number

      if (hasExistingAct) {
        const numberOnly = (act.number || '').toString().split('/')[0]
        setRow(prev => ({
          ...prev,
          number: numberOnly,
          date: act.date || prev.date,
          hour: (act.hour || prev.hour)?.substring(0, 5),
          id_participant: Array.isArray(act.id_participant) ? act.id_participant : [],
          id_book: act.id_book || ''
        }))
      } else {
        // defaults for Actas OC: predeterminados
        let defaults = []
        let nextSelectable = false
        if (participants?.length > 0) {
          defaults = participants.filter(b => parseInt(b.predeterminado_actas_oc) === 1)
          nextSelectable = participants.find(b => !defaults.some(d => parseInt(d.id) === parseInt(b.id)))
        }
        let bookDefault = ''
        if (books?.length > 0) {
          const bookMain = books.find(b => parseInt(b.main) === 1)
          bookDefault = bookMain ? bookMain.id : ''
        }
        setRow(prev => ({
          ...prev,
          id_participant: defaults.map(f => f.id),
          id_book: bookDefault
        }))
        setParticipantSelected(nextSelectable ? { label: nextSelectable.name, value: nextSelectable.id } : '')
      }
      setIsOk(true)
    })
  }, [idConsolidate])

  const onSubmit = ({ e }) => {
    let $this = e.currentTarget

    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect({ form: $this, toastr });
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect({ form: $this, toastr })) {
        return;
      }
      if (row.id_participant.length === 0) {
        Helpers.toastr.construct({ response: 'warning', message: 'Por favor, seleccionar Participantes', toastr })
        return;
      }
      if (!row.id_book) {
        Helpers.toastr.construct({ response: 'warning', message: 'Por favor, seleccionar Libro', toastr })
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.orders_purchaseorder_act({
      p_id: idConsolidate,
      p_number: row.number + '/' + year,
      p_date: row.date,
      p_hour: row.hour,
      p_id_book: row.id_book,
      p_id_participant: row.id_participant
    }).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        modalHide()
        window.open(Helpers.config.api.url + '/orders/purchaseorder/acta/pdf/' + idConsolidate + '?jwt=' + jwt, '_blank')
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
    })
  }

  return <ReactPlaceholder showLoadingAnimation rows={5} type='text' ready={isOk}>
    <FormCustom className="form-row" onSubmit={onSubmit} dataSubmit={{}} viewSubmit={false}>
      <Input
        text="Nro Acta"
        placeholder="Nro Acta"
        classNameParent="col-12 col-md-6 mb-2"
        icon="fas fa-code"
        required
        value={row.number}
        onChange={e => setRow({ ...row, number: e.currentTarget.value })}
        maxLength={50}
        append={[<span className="input-group-text">/{year}</span>]}
        autoFocus
      />
      <Input
        type="date"
        text="Fecha"
        placeholder="Fecha"
        classNameParent="col-12 col-md-3 mb-2"
        icon="far fa-calendar"
        required
        value={row.date}
        onChange={e => setRow({ ...row, date: e.currentTarget.value })}
      />
      <Input
        type="time"
        text="Hora"
        placeholder="Hora"
        classNameParent="col-12 col-md-3 mb-2"
        icon="far fa-clock"
        required
        value={row.hour}
        onChange={e => setRow({ ...row, hour: e.currentTarget.value })}
      />

      <Select
        value={(() => {
          const found = listBooks.find(b => parseInt(b.id) === parseInt(row.id_book))
          return found ? { value: found.id, label: found.name } : ''
        })()}
        text="Libro *"
        options={listBooks.map(p => { return { value: p.id, label: p.name } })}
        classNameParent="col-12 col-md-6 mb-2"
        icon="fab fa-codepen"
        required
        onChange={e => setRow({ ...row, id_book: e.value })}
      />

      <div className="col-12">
        <small><strong>Información de participantes</strong></small>
      </div>
      <Select
        value={participantSelected}
        text="Participante *"
        options={listParticipants.map(p => { return { value: p.id, label: p.name, isDisabled: row.id_participant?.some(pp => parseInt(pp) === parseInt(p.id)) } })}
        classNameParent="col-12 col-md-6 mb-2"
        icon="fab fa-codepen"
        required
        onChange={e => setParticipantSelected(e)}
        append={[
          <Button onClick={_ => {
            if (participantSelected) {
              setRow({
                ...row,
                id_participant: [
                  ...row.id_participant,
                  participantSelected.value
                ]
              })
              setParticipantSelected('')
            }
          }}>
            <i className="fa fa-plus"></i>
          </Button>
        ]}
      />
      <div className="col-12">
        <div className="d-flex flex-column">
          {React.Children.toArray(row.id_participant.map(p => {
            let finded = listParticipants.find(b => parseInt(b.id) === parseInt(p))
            return <span>{finded?.name} - {finded?.type} <i className="fa fa-trash ml-2 text-danger" style={{ cursor: 'pointer' }} onClick={_ => {
              setRow({
                ...row,
                id_participant: row.id_participant.filter(pp => parseInt(p) !== parseInt(pp))
              })
            }}></i></span>
          }))}
        </div>
      </div>

      <div className="col-12 d-flex justify-content-center mt-2">
        <Button type="submit" variant="success" className="mr-2" size="sm">
          <i className="fa fa-check mr-2"></i>Generar Acta
        </Button>
        <Button variant="dark" className="mr-2" size="sm" onClick={modalHide}>
          <i className="fa fa-times mr-2"></i>Cancelar
        </Button>
      </div>
    </FormCustom>
  </ReactPlaceholder>
}

const BitacoraTimeline = ({ bitacora, recordId }) => {
  const [localBitacora, setLocalBitacora] = useState(bitacora || { insert: [], updates: [], manual: [] });
  const [showManualForm, setShowManualForm] = useState(false);
  const [manualText, setManualText] = useState('');
  const [submittingManual, setSubmittingManual] = useState(false);
  const [downloadingPdf, setDownloadingPdf] = useState(false); // 👈 nuevo

  // Si cambia la bitacora que viene del padre, la sincronizamos
  useEffect(() => {
    if (bitacora) {
      setLocalBitacora(bitacora);
    }
  }, [bitacora]);

  if (!localBitacora) return null;

  const { insert = [], updates = [], manual = [] } = localBitacora || {};

  const formatDateTime = (value) => {
    if (!value) return '';
    const d = new Date(value.replace(' ', 'T'));
    if (isNaN(d.getTime())) return value;
    return d.toLocaleString();
  };

  const getDisplayValue = (value, finalName) => {
    const chosen =
      finalName !== null &&
        finalName !== undefined &&
        finalName !== ''
        ? finalName
        : value;

    if (chosen === null || chosen === undefined || chosen === '') {
      return 'blank';
    }

    return chosen;
  };

  const handleDownloadPdf = async () => {
    try {
      setDownloadingPdf(true);

      const res = await Controllers.orders.bitacora_download_pdf({
        p_id: recordId,
      });

      if (res.response !== 'success') throw new Error('Error generando PDF');

      const { file, filename } = res.data;

      // Crear link invisible
      const link = document.createElement('a');
      link.href = file;        // Base64 PDF
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();

    } catch (error) {
      console.error(error);
    } finally {
      setDownloadingPdf(false);
    }
  };


  const handleManualSubmit = async (e) => {
    e.preventDefault();
    const text = manualText.trim();
    if (!text) return;

    try {
      setSubmittingManual(true);

      const res = await Controllers.orders.bitacora_add_entrada_manual({
        p_id: recordId,
        p_description: text,
      });

      if (res.response !== 'success') {
        throw new Error('Error al guardar la entrada manual');
      }

      const newRow = res.data;

      setLocalBitacora((prev) => {
        const prevManual = prev.manual || [];
        return {
          ...prev,
          manual: [newRow, ...prevManual],
        };
      });

      setManualText('');
      setShowManualForm(false);
    } catch (error) {
      console.error('Error agregando entrada manual', error);
    } finally {
      setSubmittingManual(false);
    }
  };

  // -------- INSERT: un solo bloque ----------
  let insertEvent = null;
  if (insert.length) {
    const sortedInsert = [...insert].sort(
      (a, b) => new Date(a.changed_at.replace(' ', 'T')) - new Date(b.changed_at.replace(' ', 'T'))
    );
    const base = sortedInsert[0];
    insertEvent = {
      changed_at: base.changed_at,
      changed_by: base.changed_by,
      rows: sortedInsert,
    };
  }

  // -------- Separar MANUAL y UPDATE que vienen del backend ----------
  const manualFromUpdates = (updates || []).filter(
    (r) => r.type_trigger && r.type_trigger.toUpperCase() === 'MANUAL'
  );

  const pureUpdates = (updates || []).filter(
    (r) => !r.type_trigger || r.type_trigger.toUpperCase() !== 'MANUAL' && r.type_trigger.toUpperCase() !== 'RETORNO DE ESTADO'
  );

  // -------- MANUAL: combinar los que vienen en "manual" local + los MANUAL de updates ----------
  const allManualRows = [...(manual || []), ...manualFromUpdates];

  const movementRows = (updates || []).filter(
    (r) => r.type_trigger && r.type_trigger.toUpperCase() === 'RETORNO DE ESTADO'
  );

  // -------- UPDATES: agrupar por fecha/hora, solo los UPDATE reales ----------
  const groupedUpdatesMap = pureUpdates.reduce((acc, row) => {
    const key = row.changed_at || 'N/A';
    if (!acc[key]) acc[key] = [];
    acc[key].push(row);
    return acc;
  }, {});

  const updateEvents = Object.keys(groupedUpdatesMap).map((changed_at) => {
    const rows = groupedUpdatesMap[changed_at];
    return {
      kind: 'UPDATE',
      changed_at,
      changed_by: rows[0].changed_by,
      rows,
    };
  });

  // -------- MANUAL: eventos individuales ----------
  const manualEvents = allManualRows.map((row) => ({
    kind: 'MANUAL',
    changed_at: row.changed_at,
    changed_by: row.changed_by,
    row,
  }));

  // -------- MOVIMIENTO DE ESTADO: eventos individuales ----------
  const movementEvents = movementRows.map((row) => ({
    kind: 'RETORNO DE ESTADO',
    changed_at: row.changed_at,
    changed_by: row.changed_by,
    row,
  }));

  // -------- Combinar MANUAL + UPDATE y ordenar de más reciente a más antiguo ----------
  const timelineEvents = [...manualEvents, ...updateEvents, ...movementEvents].sort(
    (a, b) =>
      new Date(b.changed_at.replace(' ', 'T')) - new Date(a.changed_at.replace(' ', 'T'))
  );

  console.log(timelineEvents);
  const isEmpty = !insert.length && !timelineEvents.length;

  // -------- UI: timeline con cards ----------
  const TimelineCard = ({ variant, icon, title, subtitle, badgeText, children }) => (
    <div className="d-flex mb-3">
      <div className="mr-3 d-flex flex-column align-items-center">
        <span
          className={`rounded-circle bg-${variant}`}
          style={{ width: 14, height: 14 }}
        />
      </div>
      <div className="flex-grow-1">
        <div className="card shadow-sm border-0">
          <div className="card-header py-2 d-flex justify-content-between align-items-center bg-white">
            <div>
              <small className="text-muted d-block">{subtitle}</small>
              <strong>{title}</strong>
            </div>
            {badgeText && (
              <span className={`badge badge-${variant} badge-pill`}>{badgeText}</span>
            )}
          </div>
          <div className="card-body py-2">
            {children}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="position-relative">
      {/* línea vertical del timeline */}
      <div
        style={{
          position: 'absolute',
          left: 7,
          top: 0,
          bottom: 0,
          borderLeft: '2px solid #e9ecef',
        }}
      />

      <div className="ml-4">
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <h6 className="mb-0">Bitácora</h6>
          <div className="btn-group">
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={handleDownloadPdf}
              disabled={downloadingPdf || !recordId}
            >
              {downloadingPdf ? 'Generando PDF...' : 'Descargar en PDF'}
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary"
              onClick={() => setShowManualForm((prev) => !prev)}
            >
              {showManualForm ? 'Cancelar' : 'Agregar Entrada Manual'}
            </button>
          </div>
        </div>

        {showManualForm && (
          <div className="mb-3">
            <div className="card border-0 shadow-sm">
              <div className="card-header py-2 bg-light d-flex justify-content-between align-items-center">
                <span className="font-weight-bold">Nueva entrada manual</span>
              </div>
              <div className="card-body py-2">
                <form onSubmit={handleManualSubmit}>
                  <div className="form-group mb-2">
                    <textarea
                      className="form-control"
                      rows="2"
                      placeholder="Escriba una nota o comentario para este registro..."
                      value={manualText}
                      onChange={(e) => setManualText(e.target.value)}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-sm btn-primary"
                    disabled={submittingManual || !manualText.trim()}
                  >
                    {submittingManual ? 'Guardando...' : 'Guardar entrada manual'}
                  </button>
                </form>
              </div>
            </div>
          </div>
        )}

        {isEmpty && (
          <p className="text-muted mb-3">
            No hay registros de bitácora.
          </p>
        )}

        {/* TIMELINE: MANUAL + UPDATE combinados y ordenados */}
        {timelineEvents.map((event) => {
          if (event.kind === 'MANUAL') {
            const row = event.row;
            return (
              <TimelineCard
                key={`manual-${row.id}`}
                variant="secondary"
                icon="fa-comment"
                title={row.field_name || 'Entrada manual'}
                subtitle={`${formatDateTime(row.changed_at)} • ${row.changed_by || 'system'}`}
                badgeText="MANUAL"
              >
                <p className="mb-0">
                  {row.description || 'Sin descripción'}
                </p>
              </TimelineCard>
            );
          }

          if (event.kind === 'RETORNO DE ESTADO') {
            const row = event.row;
            return (
              <TimelineCard
                key={`movement-${row.id}`}
                variant="secondary"
                icon="fa-arrow-right"
                title="Retorno de estado"
                subtitle={`${formatDateTime(row.changed_at)} • ${row.changed_by || 'system'}`}
                badgeText="RETORNO DE ESTADO"
              >
                <p className="mb-0">
                  {row.description || 'Sin descripción'}
                </p>
              </TimelineCard>
            );
          }

          // kind === 'UPDATE'
          return (
            <TimelineCard
              key={`update-${event.changed_at}`}
              variant="info"
              icon="fa-edit"
              title="Registro actualizado"
              subtitle={`${formatDateTime(event.changed_at)} • ${event.changed_by || 'system'
                }`}
              badgeText="UPDATE"
            >
              <ul className="list-unstyled mb-0">
                {event.rows.map((row) => (
                  <li key={row.id} className="mb-2">
                    <strong>{row.field_name}</strong>{' '}
                    <span className="text-muted">cambió de</span>{' '}
                    <span className="badge badge-light">
                      {getDisplayValue(row.old_value, row.old_final_name)}
                    </span>{' '}
                    <span className="text-muted">a</span>{' '}
                    <span className="font-weight-bold">
                      {getDisplayValue(row.new_value, row.new_final_name)}
                    </span>
                    {row.description && (
                      <div className="mt-1">
                        <small className="text-muted">
                          {row.description}
                        </small>
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </TimelineCard>
          );
        })}

        {/* BLOQUE INSERT (creación) SIEMPRE AL FINAL */}
        {insertEvent && (
          <TimelineCard
            variant="success"
            icon="fa-plus-circle"
            title="Registro creado"
            subtitle={`${formatDateTime(insertEvent.changed_at)} • ${insertEvent.changed_by || 'system'
              }`}
            badgeText="INSERT"
          >
            <ul className="list-unstyled mb-0">
              {insertEvent.rows.map((row) => (
                <li key={row.id} className="mb-1">
                  <strong>{row.field_name}</strong>{' '}
                  <span className="text-muted">se estableció en</span>{' '}
                  <span className="badge badge-light">
                    {getDisplayValue(row.new_value, row.new_final_name)}
                  </span>
                  {row.description && (
                    <div className="mt-1">
                      <small className="text-muted">
                        {row.description}
                      </small>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </TimelineCard>
        )}
      </div>
    </div>
  );
};


const Presentation = () => {
  const currentYear = useSelector(store => store.session.year)

  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);
  const [modalSize, setModalSize] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [form, setForm] = useState('');
  const [reload, setReload] = useState(true);
  const [state, setState] = useState(0)
  const [listGenerate, setListGenerate] = useState([])
  const [listCurcom, setListCurcom] = useState([])
  const [listCurcomApprove, setListCurcomApprove] = useState([])

  const jwt = useSelector(store => store.session.jwt)

  const permissions = useSelector(store => store.session.permissions)
  const actionsModule = useRef(Helpers.getActions({ permissions, name: 'ordenescompra' }))

  const [states, setStates] = useState([
    { id: 0, icon: 'fa fa-boxes mr-1', text: 'Consolidados', qty: 0 },
    { id: 1, icon: 'fas fa-shopping-cart mr-1', text: 'Con Orden De Compra', qty: 0 },
    { id: 10, icon: 'fas fa-file-signature mr-1', text: 'CUR COM', qty: 0 },
    { id: 11, icon: 'fas fa-clipboard-check mr-1', text: 'Aprobación CUR COM', qty: 0 },
    { id: 2, icon: 'fas fa-certificate mr-1', text: 'Compromiso', qty: 0 },
    { id: 12, icon: 'far fa-bell mr-1', text: 'Notificado', qty: 0 },
    { id: 3, icon: 'fa fa-check mr-1', text: 'Completado', qty: 0 },
    { id: 4, icon: 'far fa-handshake mr-1', text: 'Devengado', qty: 0 },
    { id: 5, icon: 'far fa-paper-plane mr-1', text: 'Enviado DAF', qty: 0 },
    { id: 6, icon: 'fa fa-times mr-1', text: 'Rechazado', qty: 0 },
    { id: 7, icon: 'fa fa-dollar-sign mr-1', text: 'Pagado', qty: 0 },
    { id: 8, icon: 'fa fa-ban mr-1', text: 'Anulado', qty: 0 },
  ])

  const [activeModalTab, setActiveModalTab] = useState('detalle');
  const [bitacoraLoading, setBitacoraLoading] = useState(false);
  const [bitacoraData, setBitacoraData] = useState(null);
  const [currentOrderId, setCurrentOrderId] = useState(null);

  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    if (reload) {
      Controllers.orders.get_orders_consolidate({
        p_year: currentYear
      }).then(res => {
        setRows(res.data)
      })
        .finally(() => {
          setIsProcessing(false)
          setReload(false);
        });
    }
  }, [reload, currentYear])

  const returnBackStatus = async (status, id, current_status) => {
    let title = '';
    let text = '';
    switch (status) {
      case 'pagadoback':
        title = 'Regresar a estado Enviado DAF';
        text = '¿Está seguro de regresar a estado Enviado DAF?';
        break;

      case 'enviaddafback':
        title = 'Regresar a estado Devengado';
        text = '¿Está seguro de regresar a estado Devengado?';
        break;

      case 'devengadoback':
        title = 'Regresar a estado Completado';
        text = '¿Está seguro de regresar a estado Completado?';
        break;

      case 'notificadoback':
        title = 'Regresar a estado Compromiso';
        text = '¿Está seguro de regresar a estado Compromiso?';
        break;

      case 'compromisoback':
        title = 'Regresar a estado Aprobación CUR COM';
        text = '¿Está seguro de regresar a estado Aprobación CUR COM?';
        break;

      case 'aprobacioncurback':
        title = 'Regresar a estado CUR COM';
        text = '¿Está seguro de regresar a estado CUR COM?';
        break;

      case 'curcomback':
        title = 'Regresar a estado CON ORDEN DE COMPRA';
        text = '¿Está seguro de regresar a estado CON ORDEN DE COMPRA?';
        break;

      case 'rejectedback':
        title = 'Regresar a estado ENVIADO DAF';
        text = '¿Está seguro de regresar a estado ENVIADO DAF?';
        break;
      default:
        break;
    }

    const result = await Swal.fire({
      title: title,
      html: `
        <p>${text}</p>
        <textarea id="swal-justification" class="swal2-textarea" placeholder="Ingrese una justificación..." style="height:120px"></textarea>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, confirmar',
      confirmButtonColor: '#376A87',
      cancelButtonText: 'No',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        const justification = document.getElementById('swal-justification').value.trim();

        if (!justification) {
          Swal.showValidationMessage('La justificación es obligatoria.');
          return false;
        }

        return Controllers.orders.orders_back_status({
          p_id: id,
          p_current_status: current_status,
          p_justification: justification
        })
          .then(res => {
            if (res.response !== 'success') {
              throw new Error(res.message || 'Error al procesar');
            }
            return res;
          })
          .catch(error => {
            Swal.showValidationMessage(
              `${error?.response?.data?.message || error.message || 'Error al procesar'}`
            );
          });
      }
    });
    if (result.isConfirmed && result.value) {
      const res = result.value;
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      setReload(true);
    }
  }

  const handleUpdate = useCallback(e => {
    setShowAll(true);
    const { number = '', id, state, typeOrder, disabled = 0 } = e.currentTarget.dataset;
    let button = e.currentTarget
    let buttonHTML = button.innerHTML;
    button.innerHTML = Helpers.icon.spin()

    setModalTitle(<><i className="fa fa-plus mr-2"></i> Generar Orden De Compra {number}</>);
    setModalSize('xl');
    setModalHeader('');

    setCurrentOrderId(id);
    setActiveModalTab('detalle');
    setBitacoraData(null);
    setBitacoraLoading(false);

    let prom = [
    ]
    if (parseInt(state) !== 0) {
      prom.push(Controllers.orders.get_orders_consolidate_id({
        p_id: id
      }))
    }

    Promise.all(prom).then(res => {
      setForm(<PresentationForm typeOrder={typeOrder} disabled={parseInt(disabled) === 1} data={parseInt(state) !== 0 ? res[0].data : {}} state={parseInt(state)} idConsolidate={id} onSubmit={onSubmit} />);
      setModalShow(true);
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
      setModalShow(false);
    }).finally(() => button.innerHTML = buttonHTML)
  }, [])

  const handleModalTabChange = (key) => {
    setActiveModalTab(key);

    if (key === 'bitacora' && currentOrderId && !bitacoraData && !bitacoraLoading) {
      setBitacoraLoading(true);

      Controllers.orders.get_bitacora_orders_consolidate_id({
        p_id: currentOrderId
      })
        .then(res => {
          setBitacoraData({ insert: res.data.bitacora_created, updates: res.data.bitacora_updated });
        })
        .catch(req => {
          Helpers.promise.catch({ req, toastr });
        })
        .finally(() => {
          setBitacoraLoading(false);
        });
    }
  };

  const onSubmit = ({ e, dataSubmit }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }

      if (dataSubmit.p_quarter === '' || dataSubmit.p_id_type_purchase === '' || dataSubmit.p_id_provider === '') {
        Helpers.toastr.construct({
          message: 'Por favor, ingresar los campos obligatorios',
          response: 'warning',
          toastr
        })
        return
      }

      let hasRecibo = dataSubmit.p_unit.some(u => u.p_number_invoice)
      if (hasRecibo) {
        if (!dataSubmit.p_invoices.length) {
          Helpers.toastr.construct({
            message: 'Existe una unidad con recibo. Por favor, ingrese la factura',
            response: 'warning',
            toastr
          })
          return
        }
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    Controllers.orders.purchase_orders_update(dataSubmit).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      if (res.response === 'success') {
        setModalShow(false);
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
      setReload(true)
    });
  }

  useEffect(() => {
    setListGenerate([])
    setListCurcom([])
    setListCurcomApprove([])
  }, [rows])

  const dtRows = useMemo(() => {
    let thead = [
      { name: 'Nro Consolidación', align: 'center' },
      { name: 'Proveedor' },
      { name: 'Cuatri.', align: 'center' },
      { name: 'Nro Orden', align: 'center' },
      { name: 'Fecha Orden', align: 'center' },
      { name: 'Insumo' },
      { name: 'Cantidad', align: 'center' },
      { name: 'Total', align: 'center' },
      { name: 'Tipo Compra', align: 'center' },
      { name: 'Estado', align: 'center' },
      { name: 'Acc.', align: 'center', sort: false },
    ];
    if (parseInt(state) === 1 && actionsModule.current.curcom) {
      thead.push({ name: 'CUR COM', align: 'center', sort: false });
    }
    if (parseInt(state) === 10 && actionsModule.current.aprobacioncurcom) {
      thead.push({ name: 'Apr. CUR COM', align: 'center', sort: false });
    }
    thead.push({ name: <i className="fa fa-check"></i>, align: 'center', sort: false });

    return <DataTable
      columnOrder={1}
      isProcessing={isProcessing}
      tbody={rows.map(r => {
        return {
          number_resolution: !isNaN(parseInt(r.number_resolution)) ? parseInt(r.number_resolution) : r.number_resolution,
          provider: r.provider,
          quarter: r.quarter,
          number_purchase: !isNaN(parseInt(r.number_purchase)) ? parseInt(r.number_purchase) : r.number_purchase,
          date_issue: r.date_issue,
          supplie: r.supplie,
          qty: !isNaN(parseInt(r.qty)) ? parseInt(r.qty) : r.qty,
          total: !isNaN(parseFloat(r.total)) ? parseFloat(r.total) : r.total,
          type_purchase: r.type_purchase,
          state: r.state,
          type_order: r.type_order,
          id: r.id,
          act_number: r.act_number,
        }
      }).filter(r => {
        if (parseInt(r.state) === state) {
          return r;
        }
        return false;
      })}
      thead={thead}
      render={tbody => tbody.map(r => {
        let rowRender = [];
        const typePurchaseNormalized = (r.type_purchase || '').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const isBajaCuantia = typePurchaseNormalized.includes('baja cuantia');
        let i = 0;
        for (let key in r) {
          if (key === 'id' || key === 'type_order' || key === 'act_number') {
            continue
          }
          let color = ''
          let texto = ''
          switch (parseInt(r.state)) {
            case 0:
              color = 'warning'
              texto = 'SIN ORDEN DE COMPRA'
              break;
            case 1:
              color = 'info'
              texto = 'CON ORDEN DE COMPRA'
              break;
            case 10:
              color = 'secondary'
              texto = 'CUR COM'
              break;
            case 11:
              color = 'secondary'
              texto = 'APROBACIÓN CUR COM'
              break;
            case 2:
              color = 'primary'
              texto = 'COMPROMISO'
              break;
            case 12:
              color = 'info'
              texto = 'NOTIFICADO'
              break;
            case 3:
              color = 'dark'
              texto = 'COMPLETADO'
              break;
            case 4:
              color = 'info'
              texto = 'DEVENGADO'
              break;
            case 5:
              color = 'primary'
              texto = 'ENVIADO DAF'
              break;
            case 6:
              color = 'danger'
              texto = 'RECHAZADO'
              break;
            case 7:
              color = 'success'
              texto = 'PAGADO'
              break;
            case 8:
              color = 'danger'
              texto = 'ANULADO'
              break;
            case 9:
              color = 'primary'
              texto = 'CON DOCUMENTACIÓN'
              break;
            default:
              break;
          }


          if (key === 'state') {
            rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>
              <strong className={'text-' + color}>{texto}</strong>
            </td>);
          } else {
            rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>{r[key]}</td>);
          }
          i++;
        }

        rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>
          {parseInt(r.state) > 0 && actionsModule.current.viewpurchaseorder ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.viewpurchaseorder.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.viewpurchaseorder.color} data-disabled={1} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={handleUpdate}>
              <i className={actionsModule.current.viewpurchaseorder.icon}></i>
            </Button>
          </OverlayTrigger> : ''}


          {parseInt(r.state) === 0 && actionsModule.current.purchaseorder ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.purchaseorder.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.purchaseorder.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={handleUpdate}>
              <i className={actionsModule.current.purchaseorder.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 0 && actionsModule.current.freeorder ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.freeorder.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.freeorder.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={e => {
              const { id = '', number } = e.currentTarget.dataset;
              setModalTitle(<><i className="fa fa-trash mr-2"></i> Liberar Pedidos</>);
              setModalHeader('bg-danger');
              setModalSize('sm');
              setForm(<div className="d-flex flex-column align-items-center">
                <p><strong>¿Libear Pedidos #{number}?</strong></p>

                <div>
                  <Button variant="danger" className="mr-2" size="sm" onClick={e => {
                    let button = e.currentTarget
                    let buttonHTML = button.innerHTML;
                    button.innerHTML = Helpers.icon.spin()

                    Controllers.orders.orders_free({
                      p_id: id
                    }).then(res => {
                      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
                    }).catch(req => {
                      Helpers.promise.catch({ req, toastr });
                    }).finally(() => {
                      button.innerHTML = buttonHTML;
                      setReload(true)
                      setModalShow(false);
                    });
                  }}>
                    <i className="fa fa-check mr-2"></i>Si
                  </Button>
                  <Button variant="dark" className="mr-2" size="sm" onClick={() => setModalShow(false)}>
                    <i className="fa fa-times mr-2"></i>No
                  </Button>
                </div>
              </div>);
              setModalShow(true)
            }}>
              <i className={actionsModule.current.freeorder.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
          {(parseInt(r.state) === 1 || parseInt(r.state) === 2 || parseInt(r.state) === 9 || parseInt(r.state) === 3 || parseInt(r.state) === 4 || parseInt(r.state) === 10 || parseInt(r.state) === 11 || parseInt(r.state) === 12) && actionsModule.current.update ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.update.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.update.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={handleUpdate}>
              <i className={actionsModule.current.update.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 2 && actionsModule.current.notificado ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              Notificar envío a proveedor
            </Tooltip>}
          >
            <Button variant="success" size="xs" className="mr-1" onClick={() => {
              setModalHeader('bg-success')
              setModalSize('sm')
              setModalTitle('Notificar Envío Proveedor ' + r.number_purchase)
              setForm(<Notificado idConsolidate={r.id} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className="far fa-bell"></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 11 && actionsModule.current.commitment ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.commitment.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.commitment.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              setModalHeader('bg-success')
              setModalSize('sm')
              setModalTitle('Generar Compromiso De Orden De Compra ' + r.number_purchase)
              setForm(<Compromiso idConsolidate={r.id} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className={actionsModule.current.commitment.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 3 && actionsModule.current.accrued ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.accrued.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.accrued.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              setModalHeader('bg-success')
              setModalSize('sm')
              setModalTitle('Generar Devengado De Orden De Compra ' + r.number_purchase)
              setForm(<Devengado idConsolidate={r.id} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className={actionsModule.current.accrued.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {(parseInt(r.state) === 4 || parseInt(r.state) === 6) && actionsModule.current.senddaf ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.senddaf.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.senddaf.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              setModalHeader('bg-success')
              setModalSize('sm')
              setModalTitle('Generar Enviado DAF De Orden De Compra ' + r.number_purchase)
              setForm(<EnviadoDAF idConsolidate={r.id} isReenvied={parseInt(r.state) === 6} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className={actionsModule.current.senddaf.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 5 && actionsModule.current.refuse ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.refuse.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.refuse.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              setModalHeader('bg-danger')
              setModalSize('sm')
              setModalTitle('Rechazar De Orden De Compra ' + r.number_purchase)
              setForm(<Rechazado idConsolidate={r.id} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className={actionsModule.current.refuse.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 5 && actionsModule.current.pay ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.pay.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.pay.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              setModalHeader('bg-success')
              setModalSize('lg')
              setModalTitle('Pago De Orden De Compra ' + r.number_purchase)
              setForm(<Pagado numberPurchase={r.number_purchase} idConsolidate={r.id} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className={actionsModule.current.pay.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) > 1 && parseInt(r.state) !== 10 && parseInt(r.state) !== 11 && parseInt(r.state) !== 7 && parseInt(r.state) !== 8 && actionsModule.current.ban ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.ban.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.ban.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              setModalHeader('bg-danger')
              setModalSize('sm')
              setModalTitle('Anular Orden De Compra ' + r.number_purchase)
              setForm(<Anulado idConsolidate={r.id} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className={actionsModule.current.ban.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 7 && actionsModule.current.print ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.print.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.print.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              window.open(Helpers.config.api.url + '/orders/consolidate/get/pdf/' + r.id + '?jwt=' + jwt, '_blank')
            }}>
              <i className={actionsModule.current.print.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {(parseInt(r.state) === 3 || parseInt(r.state) === 4 || parseInt(r.state) === 5 || parseInt(r.state) === 6 || parseInt(r.state) === 7) && isBajaCuantia && actionsModule.current.purchaseorderacta ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.purchaseorderacta.description}
            </Tooltip>}
          >
            <Button variant={'danger'} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => {
              setModalHeader('bg-success')
              setModalSize('lg')
              setModalTitle('Acta Orden De Compra ' + r.number_purchase)
              setForm(<ActaOrdenCompra idConsolidate={r.id} numberPurchase={r.number_purchase} modalHide={() => {
                setReload(true)
                setModalShow(false)
              }} />)
              setModalShow(true)
            }}>
              <i className={actionsModule.current.purchaseorderacta.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 7 && actionsModule.current.pagadoback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.pagadoback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.pagadoback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('pagadoback', r.id, r.state)}>
              <i className={actionsModule.current.pagadoback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 5 && actionsModule.current.enviaddafback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.enviaddafback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.enviaddafback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('enviaddafback', r.id, r.state)}>
              <i className={actionsModule.current.enviaddafback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 4 && actionsModule.current.devengadoback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.devengadoback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.devengadoback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('devengadoback', r.id, r.state)}>
              <i className={actionsModule.current.devengadoback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 12 && actionsModule.current.notificadoback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.notificadoback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.notificadoback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('notificadoback', r.id, r.state)}>
              <i className={actionsModule.current.notificadoback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 2 && actionsModule.current.compromisoback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.compromisoback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.compromisoback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('compromisoback', r.id, r.state)}>
              <i className={actionsModule.current.compromisoback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 11 && actionsModule.current.aprobacioncurback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.aprobacioncurback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.aprobacioncurback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('aprobacioncurback', r.id, r.state)}>
              <i className={actionsModule.current.aprobacioncurback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 10 && actionsModule.current.curcomback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.curcomback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.curcomback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('curcomback', r.id, r.state)}>
              <i className={actionsModule.current.curcomback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}

          {parseInt(r.state) === 6 && actionsModule.current.rejectedback ? <OverlayTrigger
            placement="top"
            overlay={props => <Tooltip {...props}>
              {actionsModule.current.rejectedback.description}
            </Tooltip>}
          >
            <Button variant={actionsModule.current.rejectedback.color} data-type-order={r.type_order} size="xs" data-number={r.number_purchase} className="mr-1" data-id={r.id} data-state={r.state} onClick={() => returnBackStatus('rejectedback', r.id, r.state)}>
              <i className={actionsModule.current.rejectedback.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
        </td>);

        if (parseInt(state) === 1 && actionsModule.current.curcom) {
          rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>
            <CheckBox
              id={'chk-curcom-' + r.id}
              onChange={e => {
                if (e.target.checked) {
                  setListCurcom([
                    ...listCurcom,
                    r.id
                  ])
                } else {
                  setListCurcom(listCurcom.filter(id => parseInt(id) !== parseInt(r.id)))
                }
              }}
              checked={listCurcom.some(id => parseInt(id) === parseInt(r.id))}
            />
          </td>)
        }
        if (parseInt(state) === 10 && actionsModule.current.aprobacioncurcom) {
          rowRender.push(<td align={thead[i].align ? thead[i].align : ''}>
            <CheckBox
              id={'chk-curcom-approve-' + r.id}
              onChange={e => {
                if (e.target.checked) {
                  setListCurcomApprove([
                    ...listCurcomApprove,
                    r.id
                  ])
                } else {
                  setListCurcomApprove(listCurcomApprove.filter(id => parseInt(id) !== parseInt(r.id)))
                }
              }}
              checked={listCurcomApprove.some(id => parseInt(id) === parseInt(r.id))}
            />
          </td>)
        }

        let showCheck = true

        if (listGenerate.length) {
          showCheck = listGenerate.some(l => l.provider === r.provider)
        }

        rowRender.push(<td>
          {parseInt(r.state) !== 0 && parseInt(r.state) !== 8 && showCheck ? <CheckBox
            id={'chk-generate-' + r.id}
            onChange={e => {
              if (e.target.checked) {
                setListGenerate([
                  ...listGenerate,
                  {
                    id: r.id,
                    provider: r.provider
                  }
                ])
              } else {
                setListGenerate(listGenerate.filter(l => parseInt(l.id) !== parseInt(r.id)))
              }
            }}
            checked={listGenerate.some(l => parseInt(r.id) === parseInt(l.id))}
          /> : ''}
        </td>)

        return (<tr>
          {React.Children.toArray(rowRender)}
        </tr>);
      })}
    />
  }, [isProcessing, rows, handleUpdate, state, jwt, listGenerate, listCurcom, listCurcomApprove])

  const changeList = e => {
    setState(parseInt(e.currentTarget.dataset.id))
  }

  useEffect(() => {
    let qtys = {
      0: 0,
      1: 0,
      2: 0,
      10: 0,
      11: 0,
      12: 0,
      3: 0,
      4: 0,
      5: 0,
      6: 0,
      7: 0,
      8: 0,
      9: 0,
    }
    rows.forEach(r => {
      switch (parseInt(r.state)) {
        case 0:
          qtys[0] = qtys[0] + 1
          break;
        case 1:
          qtys[1] = qtys[1] + 1
          break;
        case 10:
          qtys[10] = qtys[10] + 1
          break;
        case 11:
          qtys[11] = qtys[11] + 1
          break;
        case 2:
          qtys[2] = qtys[2] + 1
          break;
        case 12:
          qtys[12] = qtys[12] + 1
          break;
        case 3:
          qtys[3] = qtys[3] + 1
          break;
        case 4:
          qtys[4] = qtys[4] + 1
          break;
        case 5:
          qtys[5] = qtys[5] + 1
          break;
        case 6:
          qtys[6] = qtys[6] + 1
          break;
        case 7:
          qtys[7] = qtys[7] + 1
          break;
        case 8:
          qtys[8] = qtys[8] + 1
          break;
        case 9:
          qtys[9] = qtys[9] + 1
          break;
        default:
          break;
      }
    })
    setStates([
      { id: 0, icon: 'fa fa-boxes mr-1', text: 'Consolidados', qty: qtys[0] },
      { id: 1, icon: 'fas fa-shopping-cart mr-1', text: 'Con OC', qty: qtys[1] },
      { id: 10, icon: 'fas fa-file-signature mr-1', text: 'CUR COM', qty: qtys[10] },
      { id: 11, icon: 'fas fa-clipboard-check mr-1', text: 'Aprobación CUR', qty: qtys[11] },
      { id: 2, icon: 'fas fa-certificate mr-1', text: 'Compromiso', qty: qtys[2] },
      { id: 12, icon: 'far fa-bell mr-1', text: 'Notificado', qty: qtys[12] },
      { id: 9, icon: 'fas fa-certificate mr-1', text: 'Con Documentos', qty: qtys[9] },
      { id: 3, icon: 'fa fa-check mr-1', text: 'Completado', qty: qtys[3] },
      { id: 4, icon: 'far fa-handshake mr-1', text: 'Devengado', qty: qtys[4] },
      { id: 5, icon: 'far fa-paper-plane mr-1', text: 'Enviado DAF', qty: qtys[5] },
      { id: 6, icon: 'fa fa-times mr-1', text: 'Rechazado', qty: qtys[6] },
      { id: 7, icon: 'fa fa-dollar-sign mr-1', text: 'Pagado', qty: qtys[7] },
      { id: 8, icon: 'fa fa-ban mr-1', text: 'Anulado', qty: qtys[8] },
    ])
  }, [rows,]);

  return <>
    <Card>
      <Card.Header className="justify-content-between">
        <span>Listado De Ordenes De Compra</span>
        <div className="d-flex">
          {actionsModule.current.curcom && <Button onClick={async () => {
            const result = await Swal.fire({
              title: 'Enviar a CUR COM',
              text: '¿Está seguro de enviar a CUR COM los ' + listCurcom.length + ' registro(s)?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: 'Sí, confirmar',
              confirmButtonColor: '#376A87',
              cancelButtonText: 'No',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return Controllers.orders.orders_curcom({
                  p_ids: listCurcom
                }).then(res => {
                  if (res.response !== 'success') {
                    throw new Error(res.message || 'Error al procesar');
                  }
                  return res;
                }).catch(error => {
                  Swal.showValidationMessage(
                    `${(error && (error.response?.data?.message || error.message)) || 'Error al procesar'}`
                  );
                });
              }
            });
            if (result.isConfirmed && result.value) {
              const res = result.value;
              Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
              setListCurcom([]);
              setReload(true);
            }
          }} disabled={!(parseInt(state) === 1 && listCurcom.length)} className="align-self-center mr-2" variant="secondary" size="sm">
            <i className="fas fa-file-signature"></i>
            <span className="ml-2 d-none d-md-inline-block">CUR COM</span>
            <span className="ml-2">({listCurcom.length})</span>
          </Button>}
          {actionsModule.current.aprobacioncurcom && <Button onClick={async () => {
            const result = await Swal.fire({
              title: 'Enviar a Aprobación CUR COM',
              text: '¿Está seguro de aprobar los ' + listCurcomApprove.length + ' registro(s)?',
              icon: 'question',
              showCancelButton: true,
              confirmButtonText: 'Sí, confirmar',
              confirmButtonColor: '#376A87',
              cancelButtonText: 'No',
              allowOutsideClick: false,
              allowEscapeKey: false,
              showLoaderOnConfirm: true,
              preConfirm: () => {
                return Controllers.orders.orders_curcom_approve({
                  p_ids: listCurcomApprove
                }).then(res => {
                  if (res.response !== 'success') {
                    throw new Error(res.message || 'Error al procesar');
                  }
                  return res;
                }).catch(error => {
                  Swal.showValidationMessage(
                    `${(error && (error.response?.data?.message || error.message)) || 'Error al procesar'}`
                  );
                });
              }
            });
            if (result.isConfirmed && result.value) {
              const res = result.value;
              Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
              setListCurcomApprove([]);
              setReload(true);
            }
          }} disabled={!(parseInt(state) === 10 && listCurcomApprove.length)} className="align-self-center mr-2" variant="secondary" size="sm">
            <i className="fas fa-clipboard-check"></i>
            <span className="ml-2 d-none d-md-inline-block">Aprob. CUR COM</span>
            <span className="ml-2">({listCurcomApprove.length})</span>
          </Button>}
          <Button onClick={() => {
            let p_list_oc = listGenerate.map(r => r.id)

            Controllers.orders.get_reporte_oc_unit_qty({
              p_list_oc,
              p_name_provider: listGenerate[0].provider.replace(' - ', '_')
            }).then(res => {
              let a = document.createElement('a')
              a.download = res.data.filename
              a.href = res.data.file
              a.click()
              setListGenerate([])
            })
          }} disabled={!listGenerate.length} className="align-self-center" variant="success" size="sm">
            <i className="fa fa-file-excel"></i>
            <span className="ml-2 d-none d-md-inline-block">Descargar Reporte</span>
            <span className="ml-2">({listGenerate.length})</span>
          </Button>
          <Button size="sm" onClick={() => { setListGenerate([]); setListCurcom([]); setListCurcomApprove([]); }} variant="danger">
            <i className="fa fa-times"></i><span className="ml-2 d-none d-md-inline-block">Cancelar</span>
          </Button>
        </div>
      </Card.Header>
      <Card.Body>
        {React.Children.toArray(states.map(st => {
          return <Button size="sm" data-id={st.id} onClick={changeList} variant={state === st.id ? 'success' : 'primary'} className="mr-2"><i className={'mr-1 ' + st.icon}></i>{st.text} ({st.qty})</Button>
        }))}
        <div className="mb-2"></div>
        {dtRows}
      </Card.Body>
    </Card>
    <Modal show={modalShow} onHide={() => {
      setShowAll(false);
      setModalShow(false);
    }} size={modalSize} backdrop="static">
      <Modal.Header closeButton className={modalHeader}>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {showAll ? <Tabs
          id="order-modal-tabs"
          activeKey={activeModalTab}
          onSelect={handleModalTabChange}
        >
          <Tab eventKey="detalle" title="Detalle">
            <div className="pt-3">
              {form}
            </div>
          </Tab>

          <Tab eventKey="bitacora" title="Bitácora">
            <div className="pt-3">
              {bitacoraLoading && (
                <p className="text-muted">Cargando bitácora...</p>
              )}
              {!bitacoraLoading && (
                <BitacoraTimeline bitacora={bitacoraData} recordId={currentOrderId} />
              )}
            </div>
          </Tab>
        </Tabs> : form}
      </Modal.Body>
    </Modal>
  </>
}

export default Presentation;